import { httpClient } from './http-client';

export const getAllNews = async (query) => {
  const result = await httpClient.get('api/all_news.php', {
    params: query,
  });

  return result.data;
};

export const getTopNews = async () => {
  const result = await httpClient.get('api/news.php');

  return result.data.map((x) => {
    return {
      img: x.n_pics,
      date: x.n_date,
      title: x.n_title,
      desc: x.n_text,
      id: x.n_id,
    };
  });
};

export const getNewsDetail = async (id) => {
  const result = await httpClient.get('api/get_detail_news.php', {
    params: {
      id: id,
    },
  });

  return result.data;
};
